import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=625d895a&lang=pug&"
import script from "./Partner.vue?vue&type=script&lang=coffee&"
export * from "./Partner.vue?vue&type=script&lang=coffee&"
import style0 from "./Partner.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports